import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalState } from "..";

type SetProductAmortizationYParams = {
  formId: string;
  value: string;
};

function SetProductAmortizationYReducer(
  state: ProposalState,
  { payload: { formId, value } }: PayloadAction<SetProductAmortizationYParams>,
) {
  state.productByFormId[formId].commercialConditions.amortizationY = value;
}

export default SetProductAmortizationYReducer;
